import React, { useEffect, useState } from "react";
import "./RecoveryDetails.css";
import { Col, Container, Row } from "react-bootstrap";
import { FaStarOfLife } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi";
import { BsThreeDotsVertical } from "react-icons/bs";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import axios from "axios";

const RecoveryDetails = ({
  recoveryData = {}, // Default to empty object to prevent undefined errors
  isEditing,
  onRecoveryChange,
  onNestedChange,
  handleSaveClick,
  onLocationChange,
  selectedFile,setSelectedFile
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [isOpenConverted, setIsOpenConverted] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [coordinates, setCoordinates] = useState([0, 0]);
  const [showDropdownOnly, setShowDropdownOnly] = useState(false);
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(recoveryData?.recoveryStatus || "Open");
  const [remark, setRemark] = useState("");
  //router type feild
  const [routerTypes, setRouterTypes] = useState([]);
const [loading, setLoading] = useState(true);
const [routerError, setRouterError] = useState(null);
  const location = useLocation();
  const hideButtons =
    location.state?.hideButtons === true ||
    location.state?.hideButtons === "true";

  const dueStatusOptions = [
    "Open",
    "Progress",
    "Collected",
    "Out of Station",
    "Not Available",
    "Expect Renewal",
    "Not Handover",
  ];

  const statusColors = {
    open: "#fbdc6e",
    progress: " #a7a7a7",
    collected: " #b0e9bd",
    "out of station": "#577590",
    "not available": " #ec8db6",
    "expect renewal": " #cfa87b",
    "not handover": " #f07c7c",
  };
  const isUpdateFlow = isEditing && recoveryData?._id;


  
const handleStatusSubmit = async (onSaveCallback) => {
  try {
    // ✅ First update all the nested recovery details
    onNestedChange("recoveryleadStatus", "recoveryimage", selectedFile?.name || "");
    onNestedChange(
      "recoveryleadStatus",
      "nextFollowUpDate",
      recoveryData?.recoveryleadStatus?.nextFollowUpDate || ""
    );
    onNestedChange(
      "recoveryleadStatus",
      "recoverynotes",
      recoveryData?.recoveryleadStatus?.recoverynotes || ""
    );

    // ✅ Then update the leadStatus at top level
    // Pass the selectedStatus to the callback to ensure it's used
    onRecoveryChange("leadStatus", selectedStatus);

    // 💾 Save data with a small delay to allow state to update
    setTimeout(async () => {
      try {
        await onSaveCallback();
        // Reset states without clearing selectedStatus
        setShowStatusPopup(false);
        setIsOpenConverted(false);
        setRemark("");
        setSelectedFile(null);
      } catch (saveError) {
        console.error("Save failed in timeout:", saveError);
      }
    }, 100);

    // Show success message (Swal is already in handleSaveClick, but keeping it here for safety)
    // Actually handleSaveClick shows its own Swal, so we could remove this one
    // but let's keep it consistent for now.
    
    // Don't clear selectedStatus here - let it persist in the UI
    // The actual status is now in recoveryData.leadStatus
    
  } catch (error) {
    console.error("Error updating status:", error);
    Swal.fire("Error", "Failed to update status", "error");
  }
};

  // Initialize coordinates when recoveryData changes
  useEffect(() => {
    if (recoveryData?.location) {
      if (Array.isArray(recoveryData.location.coordinates)) {
        setCoordinates(recoveryData.location.coordinates);
      } else if (
        recoveryData.location.latitude &&
        recoveryData.location.longitude
      ) {
        setCoordinates([
          recoveryData.location.longitude,
          recoveryData.location.latitude,
        ]);
      } else if (recoveryData.location.lng && recoveryData.location.lat) {
        setCoordinates([recoveryData.location.lng, recoveryData.location.lat]);
      }
    }
  }, [recoveryData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onRecoveryChange(name, value);
  };

  const handleNestedChange = (e) => {
    const { name, value } = e.target;
    onNestedChange("recoveryleadStatus", name, value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      onNestedChange("recoveryleadStatus", "recoveryimage", file.name);
    }
  };
  const formatLocation = (location) => {
    if (!location) return "";

    if (typeof location === "string") {
      return location;
    }

    if (location.latitude && location.longitude) {
      return `${location.latitude}, ${location.longitude}`;
    }

    if (location.lat && location.lng) {
      return `${location.lat}, ${location.lng}`;
    }

    if (Array.isArray(location.coordinates)) {
      return `${location.coordinates[1]}, ${location.coordinates[0]}`; // Note: coordinates are typically [longitude, latitude]
    }

    return "";
  };

  const preventNonNumericInput = (e) => {
    if (
      ["e", "E", "+", "-"].includes(e.key) ||
      (e.key &&
        !/[0-9]/.test(e.key) &&
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight")
    ) {
      e.preventDefault();
    }
  };
  useEffect(() => {
  // Initialize selectedStatus when data loads
  if (recoveryData?.leadStatus) {
    setSelectedStatus(recoveryData.leadStatus);
  }
}, [recoveryData?.leadStatus]);
useEffect(() => {
  const fetchRouterTypes = async () => {
    try {
      const response = await axios.get(`${apiUrl}manage-stock/get-material-type`);
      
      if (response.data && response.data.length > 0) {
        // Extract just the materialType values from response
        const types = response.data.map(item => item.materialType);
        setRouterTypes(types);
      } else {
        setRouterTypes([]);
      }
      setRouterError(null);
    } catch (err) {
      console.error("Error fetching router types:", err);
      setRouterError("Failed to load router types");
      setRouterTypes([]);
    } finally {
      setLoading(false);
    }
  };

  fetchRouterTypes();
}, []);

  // const handleMapClick = (lngLat) => {
  //   const newCoordinates = [lngLat.lng, lngLat.lat];
  //   setCoordinates(newCoordinates);
  //   onLocationChange(newCoordinates);
  // };

  // const handleCoordinateChange = (index, value) => {
  //   const newCoordinates = [...coordinates];
  //   newCoordinates[index] = parseFloat(value) || 0;
  //   setCoordinates(newCoordinates);
  //   onLocationChange(newCoordinates);
  // };

  // Component sections
  const renderHeader = () => (
    <Row className="text-start lead-id-row mb-4 mt-4 ms-4">
      <p className="ps-5 paragraph-lead-id">
        <span className="lead-start-date-recovery">
          Lead Started Date -
          <span className="text-primary">
            {recoveryData?.createdDate || "N/A"}
          </span>
        </span>
      </p>
    </Row>
  );
  //show the customerInformation section(A)
  const renderCustomerInfoSection = () => (
    <Col>
      <Row>
        <Col xs={12} md={6} className="text-start">
          <label>Customer Id *</label>
          <br />
          <input
            type="text"
            name="customerid"
            className="form-input"
            value={recoveryData?.customerid || ""}
            onChange={handleChange}
            readOnly={!isEditing}
          />
        </Col>
        <Col sm={12} md={6} className="text-start">
          <label>Customer Name *</label>
          <br />
          <input
            type="text"
            className="form-input"
            name="customername"
            value={recoveryData?.customername || ""}
            onChange={handleChange}
            readOnly={!isEditing}
            style={{ textTransform: "capitalize" }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12} className="text-start">
          <label>Address</label>
          <br />
          <textarea
            className="box-recovery"
            name="address"
            value={recoveryData?.address || ""}
            onChange={handleChange}
            readOnly={!isEditing}
            style={{ textTransform: "capitalize", resize: "none" }}
          />
        </Col>
      </Row>
    </Col>
  );
  //show the customerInformation section(B)
  const renderContactInfoSection = () => (
    <Col>
      <Row>
        <Col xs={12} md={6} className="text-start">
          <label>
            Contact Number
            <sup>
              <FaStarOfLife size={7} />
            </sup>
          </label>
          <br />
          <input
            type="tel"
            className="form-input"
            name="contactnum"
            value={recoveryData?.contactnum || ""}
            onChange={handleChange}
            readOnly={!isEditing}
            maxLength={10}
            onKeyDown={preventNonNumericInput}
          />
        </Col>

        <Col xs={12} md={6} className="text-start">
          <label>Alternate Number</label>
          <br />
          <input
            type="tel"
            className="form-input"
            name="alternatenum"
            value={recoveryData?.alternatenum || ""}
            onChange={handleChange}
            readOnly={!isEditing}
            maxLength={10}
            onKeyDown={preventNonNumericInput}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6} className="text-start">
          <label>Location *</label>
          <br />
          <input
            className="form-input"
            name="location"
            value={formatLocation(recoveryData?.location)}
            onChange={handleChange}
            readOnly={!isEditing}
          />
        </Col>
        <Col xs={12} md={6} className="text-start">
          <label>Area *</label>
          <br />
          <input
            className="form-input"
            name="area"
            value={recoveryData?.area || ""}
            onChange={handleChange}
            readOnly={!isEditing}
            style={{ textTransform: "capitalize" }}
          />
        </Col>
      </Row>
        <Row>
   <Col xs={12} md={6} className="text-start">
  <label>Router Type *</label>
  <br />
  {loading ? (
    <select className="form-input-select" disabled>
      <option>Loading router types...</option>
    </select>
  ) : routerError ? (
    <select className="form-input-select" disabled>
      <option>{routerError}</option>
    </select>
  ) : (
    <select
      className="form-input-select"
      name="routertype"
      value={recoveryData?.routertype || ""}
      onChange={(e) => onRecoveryChange(e.target.name, e.target.value)}
      disabled={!isEditing}
    >
      <option value="">Select</option>
      {routerTypes.map((type, index) => (
        <option key={index} value={type}>
          {type}
        </option>
      ))}
    </select>
  )}
</Col>

     <Col xs={12} md={6} className="text-start">
  <label>Recovery Status</label>
  <br />
  <div style={{ position: "relative", width: "100%" }}>
    {/* Main Status Box */}
    <div
      className="form-input converted-form"
      style={{
        textTransform: "capitalize",
        backgroundColor:
          statusColors[
            (
              selectedStatus ||
              recoveryData?.recoveryStatus ||
              "Open"
            ).toLowerCase()
          ] || "#fbdc6e",
        color: "rgb(20, 20, 20)",
        cursor: (hideButtons && isEditing) ? "pointer" : "default",
        borderRadius: "6px",
        padding: "8px 14px",
        width: "100%",
        pointerEvents: !isEditing ? "none" : "auto", // Disable interactions when not editing
        opacity: !isEditing ? 0.8 : 1 // Slightly fade when disabled
      }}
      onClick={() => {
        if (!isEditing) return; // Exit if not in edit mode
        
        if (hideButtons) {
          setShowDropdownOnly(!showDropdownOnly);
          setShowStatusPopup(false);
        } else {
          const currentStatus =
            selectedStatus || recoveryData?.recoveryStatus || "Open";

          if (currentStatus.toLowerCase() === "open") {
            setSelectedStatus("Open");
            setIsOpenConverted(true);
            setShowStatusPopup(true);
          }
        }
      }}
    >
      {selectedStatus || recoveryData?.leadStatus || recoveryData?.recoveryStatus || "Open"}
    </div>

    {/* Dropdown only for update flow */}
    {isEditing && hideButtons && showDropdownOnly && !showStatusPopup && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          width: "9rem",
          zIndex: 999,
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "6px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {dueStatusOptions.map((status, index) => (
          <div
            key={index}
            style={{
              padding: "5px 10px",
              cursor: "pointer",
              borderBottom:
                index !== dueStatusOptions.length - 1
                  ? "1px solid #eee"
                  : "none",
              textTransform: "capitalize",
              backgroundColor:
                statusColors[status.toLowerCase()] || "#fff",
              color: selectedStatus === status ? "#0d6efd" : "black",
              fontWeight: selectedStatus === status ? "bold" : "normal",
            }}
            onClick={() => {
              if (!isEditing) return;
              setSelectedStatus(status);
              setShowDropdownOnly(false);
              setIsOpenConverted(true);
              setShowStatusPopup(true);
            }}
          >
            {status}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* Final popup rendering in both cases */}
  {isEditing && ((hideButtons && isOpenConverted && showStatusPopup) ||
    (!hideButtons &&
      (selectedStatus || recoveryData?.recoveryStatus) === "Open" &&
      isOpenConverted &&
      showStatusPopup)) &&
    renderStatusModal(handleSaveClick)}
</Col>
    </Row>
    </Col>
    
  );
  //router type and  recovery status section
  // const renderRouterAndStatusSection = () => (
  
  // );
  // the recovery status object and the popup
  const renderStatusModal = (onSaveCallback) => {
    const currentStatus = (
      selectedStatus ||
      recoveryData?.recoveryStatus ||
      "Open"
    ).toLowerCase();
    const popupColor = statusColors[currentStatus] || "#fbdc6e";

    return (
      <div className="overlay1-open">
        <div className="modal1-open">
          <Container>
            <button
              className="close-btn1"
              onClick={() => {
                setShowStatusPopup(false);
                setIsOpenConverted(false);
              }}
            >
              <span style={{ fontSize: "20px" }}>&times;</span>
            </button>

            {/* Title */}
            <div
              className="open-button border"
              style={{
                backgroundColor: popupColor,
                borderRadius: "5px",
                padding: "10px",
              }}
            >
              <h5
                style={{
                  textTransform: "capitalize",
                  color: ["#fbdc6e", "#f9c74f", "#f8961e"].includes(popupColor)
                    ? "rgb(94, 94, 14)"
                    : "white",
                  textAlign: "center",
                }}
              >
                {selectedStatus || recoveryData?.leadStatus || "Open"}
                
              </h5>
            </div>

            {/* Description */}
            <textarea
              placeholder="Enter Description"
              className="open-textbox"
              value={recoveryData.recoveryleadStatus?.recoverynotes || ""}
              onChange={(e) =>
                onNestedChange(
                  "recoveryleadStatus",
                  "recoverynotes",
                  e.target.value
                )
              }
              style={{ resize: "none", textTransform: "capitalize" }}
            />

            {/* File Upload */}
            <div className="upload-section">
              <label className="upload-btn">
                <FiUpload className="upload-icon" /> Upload Image
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  hidden
                />
              </label>
              {selectedFile && <p className="file-name">{selectedFile.name}</p>}
            </div>

            {/* Follow Up Date */}
            <Row>
              <Col className="date-update-textbox">
                <label>Next Follow Up Date</label>
                <br />
                <input
                  type="date"
                  className="form-input"
                  // name="nextFollowUpDate"
                  value={
                    recoveryData.recoveryleadStatus?.nextFollowUpDate || ""
                  }
                  onChange={(e) =>
                    onNestedChange(
                      "recoveryleadStatus",
                      "nextFollowUpDate",
                      e.target.value
                    )
                  }
                />
              </Col>
            </Row>

            {/* Submit */}
            <Row>
              <Col className="uploadbtn-install">
                <button
                  type="button"
                  className="blue-btn"
                  onClick={() => {
                    handleStatusSubmit(onSaveCallback);
                  }}
                >
                  Upload
                </button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  };
  return (
    <>
      <Container fluid className="mt-1">
        <div className="border-container">
          <form>
            {renderHeader()}
            <Row className="ms-3">
              {renderCustomerInfoSection()}
              {renderContactInfoSection()}
              {/* {renderRouterAndStatusSection()} */}
            </Row>
          </form>
        </div>
      </Container>

    </>
  );
};

export default RecoveryDetails;
